import {EntityFormGeneralDataSection, FormStepper} from "base/component/form";
import {
    BombeoFormCaracteristicasSection,
    BombeoFormGeneralDataFields,
    BombeoFormLocationFields,
} from ".";
import Box from "@mui/material/Box";

const BombeoCreationForm = ({onSubmit, onCancel = null}) => {
    const steps = ["Datos xerais", "Características e elementos"];

    const stepComponents = [
        <EntityFormGeneralDataSection
            fields={<BombeoFormGeneralDataFields creation={true} />}
            location={<BombeoFormLocationFields isCreationForm={true} />}
        />,
        <BombeoFormCaracteristicasSection />,
    ];

    return (
        <Box component="form" width="100%" mt={4}>
            <FormStepper
                onSubmit={onSubmit}
                onCancel={onCancel}
                steps={steps}
                stepComponents={stepComponents}
            />
        </Box>
    );
};

export default BombeoCreationForm;
